import Header from "../components/Header";
import {useEffect, useMemo, useState} from "react";
import {NavLink, useParams} from "react-router-dom";
import Data from "../../Data";
import Form from "../components/Form";
import InputWrapper from "../../components/InputWrapper";
import Error from "../components/Error";
import Meta from "../../../components/Meta";

const Create = () => {
    const { id } = useParams();

    const [experience, setExperience] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const [name, setName] = useState("");
    const [price, setPrice] = useState(0);
    const [overrideRefundWindow, setOverrideRefundWindow] = useState("");
    const [selectedEventIds, setSelectedEventIds] = useState([]);

    useEffect(async () => {
        try {
            const experience = await Data.fetchExperienceById({ id })
            setExperience(experience.data)
        } catch(error){
            window.location.href = '/admin/experiences'
        }
    }, []);

    const futureEvents = useMemo(() => experience?.futureEvents || [], [experience]);
    const toggleEvent = (eventId) => {
        setSelectedEventIds(prev => prev.includes(eventId) ? prev.filter(id => id !== eventId) : [...prev, eventId]);
    }

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true)
        try {
            if(selectedEventIds.length < 2) throw new Error("Select at least two events");
            const payload = { name, events: selectedEventIds, price: Number(price) };
            if(overrideRefundWindow !== "" && overrideRefundWindow !== null){
                payload.overrideRefundWindow = Number(overrideRefundWindow);
            }
            await Data.createBundle(payload)
            window.location.href = '/admin/experiences/' + id;
            setError(false)
        } catch(error) {
            setError(true)
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <Meta title={`Create Bundle`} />
            <Header heading={"Create Bundle"} backToLabel={experience.name} backToTo={`/admin/experiences/${id}`} />
            <div className={"p-3 lg:p-6 grid grid-cols-1 gap-3 lg:gap-6 w-full overflow-x-scroll"}>
                <Form heading={"New Bundle"} onSubmit={submit}>
                    <InputWrapper label={"Name"} input={<input type="text" value={name} onChange={e => setName(e.target.value)} />} />
                    <InputWrapper label={"Price (per person)"} input={<input type="number" value={price} onChange={e => setPrice(e.target.value)} />} />
                    <InputWrapper label={"Refund Window Override (Hours)"} input={<input type="number" value={overrideRefundWindow} onChange={e => setOverrideRefundWindow(e.target.value)} />} />
                    <div className={"mt-2"}>
                        <p className={"mb-2"}>Include events</p>
                        <div className={"max-h-64 overflow-auto border rounded-md p-2"}>
                            {futureEvents.length ? futureEvents.map(ev => {
                                const selected = selectedEventIds.includes(ev._id);
                                return (
                                    <label
                                        key={ev._id}
                                        className={`flex items-center justify-between gap-4 mb-2 py-2 px-3 rounded-md border cursor-pointer transition ${selected ? 'bg-green-100 border-green-300' : 'border-borderGrey hover:bg-backgroundGrey'}`}
                                    >
                                        <div className={"flex items-center gap-2"}>
                                            <input className="hidden" type="checkbox" checked={selected} onChange={() => toggleEvent(ev._id)} />
                                            <span>{new Date(ev.date).toLocaleDateString()} {new Date(ev.date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
                                        </div>
                                        <span className={"text-textGrey text-sm"}>({ev.ticketsRemaining} tickets remaining)</span>
                                    </label>
                                )
                            }) : <p className={"text-textGrey"}>No future events available.</p>}
                        </div>
                    </div>

                    <div className={"mt-2 flex gap-2"}>
                        <button type={"submit"} disabled={loading}
                                className={"bg-backgroundGrey border px-2.5 py-1.5 rounded-md hover:opacity-80 transition"}>{loading ? "Saving..." : "Create Bundle"}</button>
                    </div>
                    {error ? <Error message={"There was a problem creating the bundle. Please check your inputs and try again."} /> : null}
                </Form>
            </div>
        </>
    )
}

export default Create


